module.exports = __webpack_public_path__ + "img/Play_Film_mage.c1406bdf.jpg";